import React from 'react'
import Navbar from '../inc/Navbar';
import Rupaecobrick from "../images/rupaecbrick-debopriya gope.jpg";


import mbdharandsonjewellers from "../images/MBDHAR.jpg";
import Rupaecobrickphoto from "../images/rupaecobrick.jpg";
import MaryImmaculateSchoolAlumniAssociation from "../images/MISAA-LOGO.jpg";
import maklogo from "../images/mak.org.in.jpg";

import paulshotel from "../images/paulshotelkrishnagar.jpg";
import prothama from "../images/PROTHAMA - KRISHNAGAR.jpg";
import questdiagnosticskrishnagar from "../images/QUEST DIAGNOSTICS KRISHNANAGAR.jpg";
import bimanbastralaya from "../images/bimanbastralaya.jpg";

import manmohini from "../images/manmohibi.jpg";
import siddheswaribastralaya from "../images/siddheshwari bastralaya.jpg";
import drsankarkumarroy from "../images/drsankarkumarroy.jpg";
import desertmina from "../images/Desertmina.jpg";

import KrishnagarPublicSchool from "../images/Krishnagar Public School.jpg";
import AristacureBiotechprivatelimited from "../images/Aristacure Biotech Private Limited.jpg";
import balajisaree from "../images/BALAJI SAREE.jpg";
import sushadu from "../images/sushadu.jpg";
import tanmaysarkar from "../images/gppremia krishnagar.jpg"
function Businesstalk() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br/>
   <br/>
    <div className="album py-1">

        <div className="container">
            <div className='radius'>
                      <img src={tanmaysarkar} className="d-block w-100" alt="Reactjswebsitedevelopmentnadia"/>
</div>
            </div>
        </div>
      <br />
      <div className="album py-1">

        <div className="container">

          <div className="row">

            <div className="col-md-6 mt-3 me-0" >

              <h2 style={{ color: "#100F4C" }}><b>The Right Way to Success: Guided by Mr. Indian Coder</b></h2>
              <hr />
              <p className='bestwebsitedevelopmentcompany' style={{ olor: "#563D1F" }}>The best guide to business growth and the right way to success begins with clarity of vision, smart strategies, and consistent execution, and that’s exactly what you find with Mr. Indian Coder as your business guide. By focusing on market understanding, building a strong brand, delivering real value, and adopting digital growth strategies, businesses can scale faster and more sustainably. Mr. Indian Coder helps entrepreneurs and professionals navigate challenges, avoid mistakes, and apply proven methods that drive measurable results. With the right guidance, financial discipline, innovation, and customer-centric approach, success becomes not just a goal but an achievable journey. Talking to a trusted business guide like Mr. Indian Coder ensures that you take the right steps toward long-term growth and lasting success. </p>
              <p>Feel free to get in touch with me today to discuss your project.</p>
              <br />
              <h5 className='mb-2'>Contact Information:</h5>
              <div className="d-flex justify-content-between align-items-center">
                <a href="tel: +91 9933798896" className=" mb-2">
                  <div className=''>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward" viewBox="0 0 16 16">
                      <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z" />
                    </svg> +91 9933798896

                  </div>
                </a>
              </div>

            </div>
            <div className="col-md-6 mt-3">
              <div className="radiustanmaycoder">
                <div className='hoverimagecoder'>
                  <img src={Rupaecobrick} className="card-img-top image5" alt="Rupaecobrick" />
                  <div className="bestwebsitedeveloperwestbengal ">MR. INDIAN CODER</div>
                </div>
              </div>



            </div>
          </div>
        </div>
        <br />
      

      </div>

            <div className='Kalyaniwebsite'>
                <div className="album py-2">
                    <div className="container">
                        <h2 style={{ color: "#037383" }}><b>Our Development Services Are Trusted by Hon’ble MSMEs and Clients </b></h2>
                    </div>
                </div>

                <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="d-flex justify-content-start align-items-center mb-2">
                                    <div className="col-md-6 me-2 mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.mbdharandsonjewellers.com/' target='_blank' rel="noopener noreferrer">
                                                    <img id="myimage" src={mbdharandsonjewellers} className="card-img-top" alt="Mantasa" />
                                                </a>

                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-6  mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.rupaecobrick.com/' target='_blank' rel="noopener noreferrer">
                                                    <img src={Rupaecobrickphoto} className="card-img-top" alt="Rupaecobrick" />
                                                </a>

                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="d-flex justify-content-start align-items-center mb-2">
                                    <div className="col-md-6 me-2 mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://misaa.org.in/' target='_blank' rel="noopener noreferrer">

                                                    <img src={MaryImmaculateSchoolAlumniAssociation} className="card-img-top" alt="Mary Immaculate School Alumni Association" />

                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6  mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.mak.org.in/' target='_blank' rel="noopener noreferrer">
                                                    <img src={maklogo} className="card-img-top" alt="Mountaineers’ Association of Krishnanagar" />
                                                </a>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="d-flex justify-content-start align-items-center mb-2">
                                    <div className="col-md-6 me-2 mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.paulshotel.com/' target='_blank' rel="noopener noreferrer">
                                                    <img id="myimage" src={paulshotel} className="card-img-top" alt="paulshotel Krishnagar" />
                                                </a>

                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-6  mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.prothama.com/' target='_blank' rel="noopener noreferrer">
                                                    <img src={prothama} className="card-img-top" alt="prothama" />

                                                </a>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="d-flex justify-content-start align-items-center mb-2">
                                    <div className="col-md-6 me-2 mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.questdiagnostics.org.in/' target='_blank' rel="noopener noreferrer">

                                                    <img src={questdiagnosticskrishnagar} className="card-img-top" alt="questdiagnostics" />

                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6  mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://bimanbastralaya.com/' target='_blank' rel="noopener noreferrer">
                                                    <img src={bimanbastralaya} className="card-img-top" alt="bimanbastralaya" />

                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
             
                <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="d-flex justify-content-start align-items-center mb-2">
                                    <div className="col-md-6 me-2 mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.kpsnadia.org/' target='_blank' rel="noopener noreferrer">
                                                    <img id="myimage" src={KrishnagarPublicSchool} className="card-img-top" alt="KrishnagarPublicSchool"/>
                                                </a>

                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-6  mt-3">
                                        <div className='cardmotation'>
                                           <div className="card">
                                                <a href='https://www.drsankarkumarroy.com/' target='_blank' rel="noopener noreferrer">

                                                    <img src={drsankarkumarroy} className="card-img-top" alt="drsankarkumarroy" />

                                                </a>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="d-flex justify-content-start align-items-center mb-2">
                                    <div className="col-md-6 me-2 mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.aristacurebiotech.com/' target='_blank' rel="noopener noreferrer">

                                                    <img src={AristacureBiotechprivatelimited} className="card-img-top" alt="AristacureBiotechprivatelimited"/>

                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                   <div className="col-md-6  mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.sushadu.com/' target='_blank' rel="noopener noreferrer">
                                                    <img src={sushadu} className="card-img-top" alt="sushadu"/>

                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                   <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="d-flex justify-content-start align-items-center mb-2">
                                    <div className="col-md-6 me-2 mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.manmohini.com/' target='_blank' rel="noopener noreferrer">
                                                    <img id="myimage" src={manmohini} className="card-img-top" alt="manmohini" />
                                                </a>

                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-6  mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.siddheswaribastralaya.com/' target='_blank' rel="noopener noreferrer">
                                                    <img src={siddheswaribastralaya} className="card-img-top" alt="siddheswaribastralaya" />

                                                </a>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="d-flex justify-content-start align-items-center mb-2">
                                    <div className="col-md-6 me-2 mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.desertmina.com/' target='_blank' rel="noopener noreferrer">
                                                    <img src={desertmina} className="card-img-top" alt="desertmina" />

                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6  mt-3">
                                        <div className='cardmotation'>
                                            <div className="card">
                                                <a href='https://www.balajisaree.com/' target='_blank' rel="noopener noreferrer">
                                                    <img src={balajisaree} className="card-img-top" alt="balajisaree"/>

                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <br />
                <div className="container">
                    <div className="d-flex justify-content-end align-items-end mb-0">
                        <a href='our-development'>
                            <button className='nadiawebsitedevelopment mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                            </svg></button>
                        </a>
                    </div>
                </div>
                <br />

            </div>
    </div>
  )
}

export default Businesstalk